import { Injectable } from "@angular/core";
import { AnalyticsService } from "@app/core/analytics.service";

@Injectable()
export class HomePageAnalyticsService extends AnalyticsService {
  protected module = "MyOne Home Page";
  readonly cardSubmodule = "Card";
  readonly heroSubmodule = "Hero";

  getModule(): string {
    return this.module;
  }

  trackListCardLink(querySelector: string, eventName: string) {
    this.trackLink(querySelector, eventName, {
      module: this.module,
      flow: "Member Request",
      submodule: this.cardSubmodule,
    });
  }

  trackChoosePcpLink(querySelector: string) {
    this.trackLink(querySelector, "Choose PCP Clicked", {
      module: this.module,
      flow: "Account Update",
      submodule: this.cardSubmodule,
    });
  }

  trackEditPcpLink(querySelector: string) {
    this.trackLink(querySelector, "Edit PCP Clicked", {
      module: this.module,
      flow: "Account Update",
      submodule: this.cardSubmodule,
    });
  }

  trackHeroBookVisitLink(querySelector: string) {
    super.trackBookVisitLink(querySelector, {
      module: this.module,
      submodule: this.heroSubmodule,
    });
  }

  trackHeroMessageUsLink(querySelector: string) {
    this.trackLink(querySelector, "Message Us Clicked", {
      module: this.module,
      flow: "Member Request",
      submodule: this.heroSubmodule,
    });
  }

  trackHealthRecordLink(querySelector: string) {
    super.trackHealthRecordLink(querySelector, {
      module: this.module,
      submodule: this.cardSubmodule,
    });
  }

  trackPreferredPharmacyLink(querySelector: string) {
    this.trackLink(querySelector, "Preferred Pharmacy Clicked", {
      module: this.module,
      flow: "Prescription Renewal",
      submodule: this.cardSubmodule,
    });
  }

  trackRequestPrescriptionRenewalLink(querySelector: string) {
    this.trackLink(querySelector, "Request Prescription Renewal Clicked", {
      module: this.module,
      flow: "Prescription Renewal",
      submodule: this.cardSubmodule,
    });
  }

  trackHealthHistorySurveyLink(querySelector: string) {
    this.trackLink(querySelector, "Health History Survey Started", {
      module: this.module,
      flow: "Account Update",
      submodule: this.cardSubmodule,
    });
  }

  trackHomePageViewed() {
    this.trackWithDefaultProperties("Page Viewed", {
      module: this.module,
      flow: "Home Page Navigation",
    });
  }

  trackDownloadAppLinkSent() {
    this.trackWithDefaultProperties("App Link Sent", {
      module: this.module,
      submodule: this.cardSubmodule,
      flow: "Mobile Engagement",
    });
  }
}
